import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext, useEffect, useState } from 'react';

import { CardAccountListWebScreen } from './CardAccountListWeb.screen';
import { CardAccountListNativeScreen } from './CardAccountListNative.screen';
import * as ExpoLinking from 'expo-linking';
import { Linking } from 'react-native';

export interface CardAccountListProps {}

export const CardAccountListScreen: React.FC<CardAccountListProps> = () => {
  const [flag, setFlag] = useState('0');
  useEffect(() => {
    const getUrlAsync = async () => {
      const initialUrl = await Linking.getInitialURL();
      if (!initialUrl) {
        return;
      }
      const { queryParams } = ExpoLinking.parse(initialUrl);
      if (queryParams) {
        setFlag(queryParams?.flag as string);
      }
    };

    getUrlAsync();
  }, []);

  const layout = useContext(LayoutContext);
  if (layout.isMobile) {
    return <CardAccountListNativeScreen flag={flag} />;
  }

  return <CardAccountListWebScreen flag={flag} />;
};
